module.exports = __webpack_public_path__ + "img/envbusiness.0c73971f.jpg";